import { INLINE_LINK_STYLE } from '../../../../utils/styleHelpers';

export const CARD_ACTION_LINK = `text-xs ${INLINE_LINK_STYLE}`;
export const CARD_QUIET_ACTION = 'text-xs text-grey-6 hover:underline';
export const CARD_OUTLINE_BUTTON =
  'flex items-center gap-2 rounded-md border border-grey-3 bg-white px-3.5 py-2 text-sm font-medium text-grey-8 ' +
  'enabled:hover:bg-grey-1 disabled:cursor-not-allowed disabled:opacity-50';
